import contentDisposition from 'content-disposition';

// TODO implement paging in the future
export const apiCap = 100;

export function downloadResponse(response: Response) {
  const disposition = contentDisposition.parse(response.headers.get('content-disposition'));

  if (!response.ok) {
    throw response;
  } else {
    return response.blob().then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = disposition.parameters.filename;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove(); //afterwards we remove the element again
    });
  }
}
